<template>
  <button
    class="jps-round-button duration-250 generated-3"
    :disabled="disabled"
  >
    <BaseIcon v-if="icon" :name="icon" />
    <slot />
  </button>
</template>

<script lang="ts" setup>
interface Props {
  icon?: string
  innerClass?: string
  size?: 'small' | 'medium' | 'large'
  iconPosition?: 'left' | 'right'
  disabled?: boolean
  slim?: boolean
  defaultSize?: boolean
  large?: boolean
  expanded?: boolean
  expandedTouch?: boolean
  expandedDesktop?: boolean
  outlined?: boolean
}
const props = withDefaults(defineProps<Props>(), {
  innerClass: '',
  size: 'medium',
  iconPosition: 'left',
  disabled: false,
  slim: false,
  defaultSize: false,
  large: false,
  expanded: false,
  expandedTouch: false,
  expandedDesktop: false,
  outlined: false,
})

const size = computed(() => {
  return { small: 'tw-px-2-py-1', medium: 'tw-px-3-py-2', large: 'tw-px-4-py-3' }[
    props.size
  ]
})
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.jps-round-button {
  &.is-gray {
    background-color: $jps-gray-200;
    color: $text;
    &:hover { background-color: $jps-gray-400; }
  }
  &.is-blue {
    background-color: blue;
    color: white;
    &:hover { background-color: $jps-key-blue-hover; }
  }
  &.is-red {
    background-color: red;
    color: white;
    &:hover { background-color: $jps-key-red-hover; }
  }

  &.is-slim {
    padding-top: 1px;
    padding-bottom: 1px;
    line-height: 1;
  }

  &.jps-large {
    padding: 0.75rem 1.25rem;
    font-size: 1rem;
  }
}
.generated-3 {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    border-radius: 9999px;
    text-align: center;
    @include transition-all;
}
.tw-px-2-py-1 {
  padding: 0.25rem 0.5rem;
}
.tw-px-3-py-2 {
  padding: 0.5rem 0.75rem;
}
.tw-px-4-py-3 {
  padding: 0.75rem 1rem;
}
</style>
